export const INITIAL_STATE = {
  SHOW_DASHBOARD: false,
  USERS: ['Nikhil', 'Amar', 'Akbar', 'Anthony'],
  LOGIN_INDEX: 0,
  ACTIVE_CHAT_INDEX: 0,
  ACTIVE_CHAT: [],
  CHAT: []
}